
import { WorkqueueService } from './../../../../BaseFramework/core/http/workqueue.service';
import { NzMessageRef, NzMessageService } from 'ng-zorro-antd/message';
import { PolicyService } from './../../../../FunctionalModules/PolicyIssuance/policy.service';
import { UserInfoService } from './../../../../BaseFramework/core/http/user-info.service';
import { ApiRequestService } from './../../../../BaseFramework/core/http/api-request.service';
import { MetadataService } from './../../../../BaseFramework/core/http/metadata.service';
import { Component, OnInit, Input, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router'
import * as XLSX from 'xlsx';
import { IntimationService } from '../../../../BaseFramework/core/http/intimation.service';
import { AppMetadataHandler, CommonUtilty, LookupDataService } from 'app'
import * as moment from 'moment/moment';
import { Observable } from 'rxjs';
import {
  InteractService,
} from 'app'
//import { default as this.configData  } from './search-proposal.component.json';
import jsonData from './search-proposal.component.json';
import { environment } from './../../../../../environments/environment';
import { TechnicalTranslatePipe } from 'app/BaseFramework/shared/custom-pipes';
import { DataTransformService } from 'app/ViewModules/shared-services';
import { DatePipe } from '@angular/common';
import configjson from '../../../../../configs/health-nbu-transaction.json'
class SearchAPIMetaDataDO {
  key: any;
  keyDescription: any;
  valueInputType: any;
  lookupName: any;
  lookup: any;
  enable: any;
  isMandatory: Boolean;
}

@Component({
  selector: 'search-proposal',
  templateUrl: './search-proposal.component.html',
  styleUrls: ['./search-proposal.component.scss'],
  providers: [TechnicalTranslatePipe, DatePipe]
})

export class SearchProposalComponent implements OnInit {
  public CRITERIALOOKUP = [];
  public dataSet = [];
  public intimationType = null
  public proposalType = null;
  // public tabArray = [];
  public productFamilyCd = null;
  dropDownLimit = 5;
  isProductModalVisible: boolean = false
  selectedProductValue = null
  selectedLOB = null
  isCaseFrozen
  productData = []
  viewProposalModal = false;
  public intimationZeroState = {
    title: "No Proposals Found",
    message: "No proposals found for the selected criteria",
    icon: "file-search"

  }

  public bulkUploadOptions = [
    { type: "Manual Data Entry", key: "MANNUAL" },
    { type: "OCR Upload", key: "OCR" }
  ]
  userRole: any;
  headingPrefix = "";

  createNewProposal(key: string) {
    if (key == "MANNUAL") {
      this.showProductModal()
    }
    else {
      this.NewBulkIntimation('OCR Upload')
    }
  }

  NewBulkIntimation(uploadType?) {
    this.interactService.openNewBulkIntimation(uploadType)
  }
  extractTransactionFromPath() {
    this.transactionState = 'search-proposal'
  }
  configData = jsonData
  @Input() transactionState: string;
  userRoleDO: any;
  constructor(private router: Router,
    private intimationService: IntimationService,
    private metadataService: MetadataService,
    private interactService: InteractService,
    private activatedRoute: ActivatedRoute,
    private commonUtilty: CommonUtilty,
    private apiRequestService: ApiRequestService,
    private userInfoService: UserInfoService,
    private policyService: PolicyService,
    private workqueueService: WorkqueueService,
    private msgService: NzMessageService,
    private lookupDataService: LookupDataService,
    private technicalTranslatePipe: TechnicalTranslatePipe,
    public appMetadataHandler: AppMetadataHandler,
    private dataTransformService: DataTransformService,
    private datePipe: DatePipe) { }


  searchResultsList = [];
  extraExternalParams = []
  enableNewTable = true;
  searchTableHeaders = [];

  hideActionsInReport: boolean = false;
  getSearchCriteriaListArgument: string = 'searchProposal'
  environment = environment;
  enableProposal = false;
  productFamilyList=[]
  DOName = null;
  ngOnInit() {
    this.activatedRoute.data.subscribe(data => {
      this.extractTransactionFromPath();
    });
    this.lookupDataService.getLookup('productFamilyCd').subscribe(resp => {
      this.productFamilyList = resp
    })
    this.userRoleDO = this.userInfoService.getUserRoleDO();
    let userData = this.userInfoService.getUserInfo()
    let lobdata = userData.privilegeOfLob
    this.headingPrefix = "Last Five Transactions Worked On"
    if (this.userRoleDO && Object.keys(this.userRoleDO).length && this.userRoleDO.roleId == "UNDERWRITER") {
      this.enableProposal = false;
    }
    else {
      this.enableProposal = true;
    }

    this.dataTransformService.gridTransactionState = this.transactionState;
    if (lobdata) {
      this.appMetadataHandler.allowedLOB = lobdata ? this.commonUtilty.convertCSVToArray(lobdata) : this.appMetadataHandler.allowedLOB;
    }
    if (this.commonUtilty.isArrayIterable(userData)) {
      this.userRole = userData.userRoleDOList.find(item => true);
    }
    this.activatedRoute.data.subscribe(data => {
      this.intimationType = data.intimationType;
      this.proposalType = data.proposalType;
      this.hideActionsInReport = data.breadcrumb != 'Report';
      this.metadataService.getSearchCriteriaList(this.getSearchCriteriaListArgument).subscribe(resp => {
        this.CRITERIALOOKUP = this.commonUtilty.deepCopy(resp)
        this.searchTableHeaders = this.CRITERIALOOKUP.filter((data) => data.attributeType == 'IO' || data.attributeType == 'I')
        this.searchTableHeaders.sort((a, b) => a.sortOrder - b.sortOrder);
      });
    });

    this.getLatestFiveProposals(); // will fetch latest five proposals
    this.getConfigDataAndInitialize();
  }
  getLoggedinUserInfo() {
    let user = this.userInfoService.getUserInfo();
    console.log("loogged in user infor", JSON.stringify(user));
    if (this.commonUtilty.isArrayIterable(user.userRoleDOList)) {
      this.userRole = user.userRoleDOList.find(item => true);
    }
  }

  //  private searchTableHeaders: any[] = [];
  public _columnDefs: any[] = [];
  // public get searchTableHeaders(): any[] {
  //     return this._columnDefs;
  // }
  // public set searchTableHeaders(value: any[]) {
  //     this._columnDefs = this.convertLegacyConfigToNew(value['searchTableHeaders']) || value['grid-columns-defs'];
  // } 
  configDataset: any
  configPath = "/configs/health-nbu-transaction.json"
  getConfigDataAndInitialize() {

    // this.apiRequestService.get(this.configPath, null, true).subscribe(response => {

    //   this.configDataset = this.commonUtilty.deepCopy(response);
    // })
    this.configDataset = configjson;
  }
  transactionDataIO: any = [];
  proposalDataModal = 'Proposal Details';
  viewProposalData(entityGuid: any, productCd) {
    let selectedProductInEdit = {}
    selectedProductInEdit['productId'] = productCd;
    this.policyService.getPolicyByGuid(entityGuid).
      subscribe(resp => {
        this.transactionDataIO = resp;
        let DO = this.commonUtilty.getDOName(this.transactionDataIO);
        this.DOName = DO;
        if (DO && resp && resp[DO] && resp[DO]['statusCd'] == "INFORCE") {
          this.proposalDataModal = 'Policy Details';
        } else {
          this.proposalDataModal = 'Proposal Details';
        }
        this.refreshViewPolicyData();
        // this.interactService.sendIOToTransaction(serviceTask, this.selectedLOB, selectedProductInEdit, this.proposalType, transactionDataIO, this.selectedLOB);
        this.viewProposalModal = true;
      });

  }

  refreshViewPolicy: boolean = true;
  refreshViewPolicyData() {
    this.refreshViewPolicy = false;
    setTimeout(() => {
      this.refreshViewPolicy = true;
    }, 500);
  }
  showProductModal() {
    this.isProductModalVisible = true
  }
  cancelProductModal() {
    this.isProductModalVisible = false;
  }

  okProductModal() {
    this.NewProposal('SINGLELIFE', this.selectedProductValue);
    this.isProductModalVisible = false;
  }
  cancelProposalModal() {
    this.viewProposalModal = false;
  }
  okProposalModal() {
    this.viewProposalModal = false;
  }
  // start new code for nbu
  initiatedTransaction: Boolean = false;
  NewProposal(proposalType, selectedProduct?) {
    if (proposalType === 'MULTILIFE')
      this.msgService.info("Multi-Life is not currently configured");
    else {
      this.initiatedTransaction = true;
      this.dataTransformService.selectedProductType = selectedProduct.policyTypeCd;
      this.msgService.loading('Proceeding to Transaction', { nzDuration: 4000 });
      this.proposalType = proposalType;
      this.fetchUIMetadataAndOpenTransaction(selectedProduct);

    }
  }

  // end new code for nbu

  convertLegacyConfigToNew(legacyConfig) {
    let newConfigFromGridLegacyConfig;
    if (this.commonUtilty.isArrayIterable(legacyConfig)) {
      newConfigFromGridLegacyConfig = legacyConfig.map(x => {
        return {
          ...x,
          headerName: x.header,
          field: x.key,
          filter: x.searchFilter,
          sortable: x.sortFilter,
          cellRenderer: null
        }
      })
    }
    return newConfigFromGridLegacyConfig;
  }
  NewIntimation() {
    this.interactService.openNewTransaction('claimIntimation', null, null, this.configData.IntimationTypeToIntimationSourceCdMapper[this.intimationType])
  }


  public searchConfigurationZeroState = {
    title: "Search Required",
    message: "Hit search to view results",
    icon: "file-search"
  }
  rowData: []
  fetchSearchResult($event) {
    console.log("123");
    if ($event && !$event.reset) {
      if ($event && $event.results) {
        this.dataSet = $event.results;
        // this.proposalData = this.commonUtilty.deepCopy($event.results);
        // this.dataSet = this.transformValues(this.dataSet)
      } else if (!$event.results) {
        let resultKey = this.configData.StateToDOMapper[this.transactionState];
        if (resultKey) {
          this.dataSet = $event[resultKey];
          // this.proposalData = this.commonUtilty.deepCopy($event[resultKey]);
        }
      }
      console.log(this.dataSet)
      if (!this.dataSet || (this.dataSet && this.dataSet.length == 0)) {
        this.searchResultsList = [];
        this.headingPrefix = "Search Result: "
        this.searchConfigurationZeroState.title = "No Results found"
        this.searchConfigurationZeroState.message = "No records available for the selected search criteria."
        this.refreshAfterSearch()
      } else {
        this.headingPrefix = "Search Result: "
        this.searchResultsList = this.dataSet;
        //this.searchResultsList = this.transformValues(this.searchResultsList);
        this.rowData = this.commonUtilty.deepCopy(this.searchResultsList);
        this.refreshAfterSearch()
      }
      this.currentPageIndex = 1;
    } else {
      // this.fetchConfigurations();
      this.getLatestFiveProposals();
    }
  }
  searchDataIsInProcess: boolean = false;
  apiCall(methodType, url, payload?): Observable<any> {
    if (methodType == 'get' && payload)
      return this.apiRequestService[methodType](url);
    else if (methodType == 'post')
      return this.apiRequestService[methodType](url, payload);
  }

  currentPageIndex: number = 1;
  pageIndexChanged(event) {
    this.currentPageIndex = event;
  }

  filterMenuVisibilityChanged1(event) {
    this.searchValue = null;
  }
  filterMenuVisibilityChanged(event, configKey) {
    this.searchValue = null;
    this.filterKey = configKey;
    console.log("config key", this.filterKey);
  }

  getConfigKey(key) {
    this.filterKey = key;
    console.log("config key", key);
  }

  sortName: string | null = null;
  sortValue: string | null = null;

  sort(sort: { key: string; value: string }): void {
    this.sortName = sort.key;
    this.sortValue = sort.value;

    if (this.sortName && this.sortValue) {
      let orderBy = this.sortValue === 'ascend' ? 'asc' : 'desc';
      this.searchResultsList = this.commonUtilty.deepCopy(this.commonUtilty.sortObject(this.sortName, this.searchResultsList, orderBy))
    } else {
      this.searchResultsList = this.searchResultsList;
    }
    console.log("sorted searchResultsList", JSON.stringify(this.searchResultsList));
  }

  getDateString(rawDate) {
    let dateString
    if (rawDate != null) {
      dateString = moment(rawDate).format('DD MMM YYYY');
    }else {
      dateString = 'N/A'
    }
    return dateString
  }

  openTransactionDetails(serviceTask: any, entityGuid: any, productCd, baseProductFamilyCd, isEditWithConfig?) {
    let transactionDataIO: any = [];
    let selectedProductInEdit = {}
    selectedProductInEdit['productId'] = productCd;
    this.workqueueService.getWorkflowAudit(entityGuid, "").subscribe(res => {
      if (res) {
        res = this.commonUtilty.sortObject('updatedDt',res,'desc');
        if(res.length > 0){
          let item : any = res[0];
          serviceTask = item.serviceTask
          if(serviceTask == 'auto_Underwriting') serviceTask = "proposal_ManualUw"
          if ((serviceTask == "proposal_ManualUw") || serviceTask == "REFERRALS") {
            transactionDataIO = this.fetchCaseAndPassItToTransaction(entityGuid, transactionDataIO, serviceTask, selectedProductInEdit, baseProductFamilyCd);
          } else if (serviceTask == "proposal_DataEntry" || serviceTask == "proposal_CounterOffer" || serviceTask == "policyAutoUWTask"
            || serviceTask == "LIFEproposal_DataEntry" || serviceTask == "LIFEproposal_CounterOffer" || serviceTask == "policyAutoIssanceTask" || serviceTask == "LIFEpolicyAutoIssanceTask"
          ) {
            transactionDataIO = this.fetchPolicyAndPassItToTransaction(entityGuid, transactionDataIO, serviceTask, selectedProductInEdit, baseProductFamilyCd);
          }
        }
      }
    });
  }

  public _inboxType: any = null
  private fetchCaseAndPassItToTransaction(entityGuid: any, transactionDataIO: any, serviceTask: any, selectedProductInEdit,lob) {
    this.policyService.getCaseByGuid(entityGuid).
      subscribe(resp => {
        if (resp && Object.entries(resp).length > 0) {
          transactionDataIO = resp;
          let inboxType = this._inboxType
          this.interactService.sendIOToTransaction(serviceTask, lob, selectedProductInEdit, 'SINGLELIFE', transactionDataIO, null, inboxType);
          this.router.navigate(['/app/nbu/transaction/details'], { queryParams: {}, replaceUrl: false });
        }
        else {
          this.msgService.error("SERVER ERROR - Technical issue occurred, please contact IT Support.")
        }
      });
    return transactionDataIO;
  }
  private fetchPolicyAndPassItToTransaction(entityGuid: any, transactionDataIO: any, serviceTask: any, selectedProductInEdit, lob) {
    this.policyService.getPolicyByGuid(entityGuid).
      subscribe(resp => {
        if (resp && Object.entries(resp).length > 0) {
          transactionDataIO = resp;
          let inboxType = this._inboxType
          this.interactService.sendIOToTransaction(serviceTask, lob, selectedProductInEdit, 'SINGLELIFE', transactionDataIO, null, inboxType);
          // this.interactService.sendIOToTransaction(serviceTask, transactionDataIO, taskId, null, inboxType);
          this.router.navigate(['/app/nbu/transaction/details'], { queryParams: {}, replaceUrl: false });
        }
        else {
          this.msgService.error("SERVER ERROR - Technical issue occurred, please contact IT Support.")
        }
      });
    return transactionDataIO;
  }

  // extraExternalParams = [{
  //   "paramName": "baseProductFamilyCd",
  //   "paramValue": "HEALTH"
  // }]
  proposalData = []
  itemsPerPage: any = 5;
  currentPage: any = 0;
  // searchURL = "api/policy/searchProposal"
  searchURL = 'proposalSearch'
  getLatestFiveProposals() {
    this.filterKey = null;
    this.searchValue = null;
    // this.appMetadataHandler.allowedLOB = productFamilyCd
    // this.selectedLOB = productFamilyCd
    // this.newBusinessAppSettings.APPCONSTANTS.productFamilyCd = this.selectedLOB;
    var payload = {}
    payload["page"] = this.currentPage;
    payload["size"] = this.itemsPerPage;
    payload["searchCriteriaList"] = []
    var criteriaItem1 = {}
    var criteriaItem2 = {}
    let userId = null
    userId = this.userInfoService.getUserId();
    criteriaItem1 = {}
    criteriaItem1["paramName"] = 'criteriaUser'
    criteriaItem1["paramValue"] = userId
    payload["searchCriteriaList"].push(criteriaItem1)
    payload["searchCriteriaList"].push(criteriaItem2)

    this.apiRequestService.postCallWithAPIMapper(this.searchURL, payload).subscribe(data => {
      this.dataSet = this.commonUtilty.deepCopy(data.results)
      this.searchResultsList = this.commonUtilty.deepCopy(this.dataSet);
      this.refreshAfterSearch()
    });
  }

  fetchProducts(productFamilyCd) {
    this.productData = [];
    this.dataTransformService.selectedLobProducts = [];
    this.workqueueService.fetchProducts(productFamilyCd)
      .subscribe(jsonResp => {
        if (jsonResp && jsonResp.length) {
          jsonResp.forEach((criteria: any) => {
            if (criteria && Object.keys(criteria).length) {
              criteria['productNameWithVersion'] = criteria.productName + " (V" + criteria.productVersion + ")";

              if (criteria.productFamilyCd == productFamilyCd) {
                this.productData.push(criteria);
              }
            } else {
              this.productData = [];
            }
          });
          this.refreshProductList()
        }
        this.dataTransformService.selectedLobProducts = this.commonUtilty.deepCopy(this.productData);
        console.log("product data when fetching from API", JSON.stringify(this.productData));
      });
  }

  refreshProductListFl = true;
  refreshProductList(){
    this.refreshProductListFl = false
    setTimeout(()=>{
      this.refreshProductListFl = true
    }, 200)
  }


  downloadLoader: boolean = false
  fetchUIMetadataAndOpenTransaction(product) {
    if (product) {
      this.workqueueService.fetchUIMetadata(product.productId).subscribe(response => {
        console.log("metadata response", JSON.stringify(response));
        let metadataArray = response || [];
        this.metadataService.productBasedConfigData = response || [];
        this.initiatedTransaction = false;
        if (this.commonUtilty.isArrayIterable(metadataArray)) {
          metadataArray.forEach(metaData => {
            if (metaData.productCd == product.productId && !metaData.riderCd) {
              let metaDataErrorList = []
              // let metaDataErrorList = this.validationUtilService.validateMetaData(metaData.uiConfigurations)
              if (this.commonUtilty.isArrayIterable(metaDataErrorList)) {
                this.msgService.error("Error in opening transaction due to technical configuration")
              }
              else
                this.interactService.openNewTransaction('proposal_DataEntry', this.selectedLOB, product, this.configData.ProposalTypeToIntimationSourceCdMapper[this.proposalType], this.configData.TypeToIntimationSourceCdMapper[this.proposalType])
            }
          });
        }
      })
    }
  }
  filterKey = null
  searchValueInTable = null;

  searchTableData(value) {
    if (!this.commonUtilty.isArrayIterable(this.searchResultsList)) {
      this.searchResultsList = this.dataSet
    }
    if (value) {
      this.dataSet = this.searchResultsList.filter(item => item[this.filterKey] ? item[this.filterKey].toLowerCase().includes(value.toLowerCase()) : [])
      this.searchValueInTable = null;
    }
  }
  getKey(key) {

    this.filterKey = key;
    console.log("config key", key);
  }
  // reset(){
  //   this.searchValueInTable = null;
  //   this.dataSet = this.searchResultsList;
  // }

  getBaseProductCode(baseProductCd) {
    let translatedVal = this.technicalTranslatePipe.transform(baseProductCd);
    if (baseProductCd.toLowerCase() == translatedVal.toLowerCase()) {
      return "ERROR_" + baseProductCd;
    } else {
      return translatedVal;
    }
  }
  dataSubmittedFlag = false

  open = false;
  openUWrules() {
    this.open = true;
  }

  isAtleastOneHeaderIsChecked = false;
  unselectAllHeaders: boolean;
  manageHeaders1(data) {
    console.log("manager headers data", JSON.stringify(data));
    let isCheckedList = this.searchTableHeaders.filter(e => e.defaultVisibilityFl == true)
    if (isCheckedList && Array.isArray(isCheckedList) && isCheckedList.length && isCheckedList.length >= 1) {
      this.isAtleastOneHeaderIsChecked = true;
    }
    else if (isCheckedList.length < 1) this.isAtleastOneHeaderIsChecked = false;

  }
  returnVisibleColumnsLength() {
    return this.searchTableHeaders.filter(e => e.defaultVisibilityFl == true) ? this.searchTableHeaders.filter(e => e.defaultVisibilityFl == true).length : null
  }
  lastCheckboxPendingToBeUnticked() {
    return this.searchTableHeaders.filter(e => e['defaultVisibilityFl']).length == 1
  }
  manageHeaders(data) {
    console.log("manager headers data", JSON.stringify(data));
  }


  isOneHeaderChecked = false;
  unselectAll() {
    this.searchTableHeaders.forEach(e => e['defaultVisibilityFl'] = false)
    this.searchTableHeaders[0].defaultVisibilityFl = true;
    this.lastCheckboxPendingToBeUnticked();
  }
  getDate(date) {
    let dateString;
    if (date != null) {
      if (Array.isArray(date)) {
        let [year, month, day] = date;
        let momentDate = moment({ year, month: month - 1, day });

        if (momentDate.isSameOrBefore(moment(), 'day')) {
          dateString = momentDate.format(this.appMetadataHandler.GLOBAL_DATE_FORMAT_MOMENT);
        } else {
          dateString = '-';
        }
      } else {
        dateString = '-';
      }
    } else {
      dateString = '-';
    }
    return dateString;
  }
  searchValue: null;
  searchConfiguration() {
    let value: any = this.searchValue;
    if (value) {
      if (!isNaN(value)) {
        let filterVal = this.dataSet.filter(item => item[this.filterKey] ? item[this.filterKey].toLowerCase().includes(value.toLowerCase()) : [])
        if (!this.commonUtilty.isArrayIterable(filterVal)) {
          this.searchResultsList = this.dataSet.filter(item => item[this.filterKey] ? item[this.filterKey] == value : []);
          this.searchResultsList = this.searchResultsList.filter(item => item[this.filterKey])
        } else {
          this.searchResultsList = filterVal.filter(item => item[this.filterKey])
        }
      }
      else {
        this.searchResultsList = this.dataSet.filter(item => item[this.filterKey] ? item[this.filterKey].toLowerCase().includes(value.toLowerCase()) : [])
        this.searchResultsList = this.searchResultsList.filter(item => item[this.filterKey])
      }
      this.searchValue = null;
    }
  }
  reset(): void {
    this.searchValue = null;
    this.searchResultsList = this.dataSet;
  }

  private transformValues(list) {
    if (this.commonUtilty.isArrayIterable(list)) {
      list.forEach((row: any) => {
        let searchResultKeys = Object.keys(row);
        if (this.commonUtilty.isArrayIterable(searchResultKeys)) {
          if (this.commonUtilty.isArrayIterable(this.searchTableHeaders)) {
            this.searchTableHeaders.forEach(config => {
              if (searchResultKeys.includes(config.field) && (config['pipe'] && config['pipe'] == 'technicalTranslate') && !config['isCSV']) {
                row[config.field] = this.technicalTranslatePipe.transform(row[config.field], config['pipeValue']);
              }
              if (searchResultKeys.includes(config.field) && (config['pipe'] && config['pipe'] == 'technicalTranslate') && config['isCSV']) {
                if (row[config.field]) {
                  let splitValue = row[config.field] && row[config.field].includes(',') ? row[config.field].split(',') : row[config.field];
                  if (this.commonUtilty.isArrayIterable(splitValue)) {
                    splitValue = this.commonUtilty.convertArrayToCSV(splitValue);
                    // splitValue.join(',');
                  }
                  row[config.field] = splitValue
                }
              }
              if (config['pipe'] && config['pipe'] == 'date') {
                if (row[config.field] && Array.isArray(row[config.field])) {
                  row[config.field] = this.commonUtilty.serverDOtoUIDODate(row[config.field]);
                }

                if (row[config.field])
                  row[config.field] = this.datePipe.transform(row[config.field], this.appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR);
              }



            });
          }
        }
        row['fullName'] = row['firstName'] + (row['lastName'] ? (" " + row['lastName']) : '')

      });
    }
    return list;
  }


  getSelectedCriteria(criteria) {
    if (criteria.selectedCriteriaKey === 'planTypeCd') {
      let criteria = { paramName: 'planTypeCd', paramValue: 'TEMPLATE' };
      this.extraExternalParams = this.commonUtilty.uniquePushInArray(this.extraExternalParams, criteria, 'paramName')
    } else {
      if (this.transactionState == 'product') {
        let basePlanCriteria = { paramName: 'planTypeCd', paramValue: 'BASEPLAN' };
        this.extraExternalParams = this.commonUtilty.uniquePushInArray(this.extraExternalParams, basePlanCriteria, 'paramName');
      }
    }
    console.log("selectedCriteria", criteria);
  }
  createTemplateExcel() {
    let wb = XLSX.utils.book_new();
    let searchHeader = this.searchTableHeaders.map(headerConfig => headerConfig['header']);
    let searchData = this.searchResultsList.map(data => {
      let mappedData = [];
      this.searchTableHeaders.forEach(headerConfig => {
        if (!headerConfig.pipe) {
          mappedData.push(data[headerConfig.field]);
        }
        else if (headerConfig.pipe && headerConfig.pipe == 'technicalTranslate') {
          // mappedData.push((headerConfig.key == 'vocabularyType' && data[headerConfig.key] === 'SYSTEM') ? 'System' : (this.technicalTranslatePipe.transform(data[headerConfig.key])));
          mappedData.push(this.technicalTranslatePipe.transform(data[headerConfig.key]));
        }
        // else if (this.searchResultsList[headerConfig.key] && headerConfig.pipe && headerConfig.pipe == 'date') {
        //     mappedData.push(this.dateTransform.transform(this.searchResultsList[headerConfig.key], this.appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR, 'GMT'));
        // }
        else if (headerConfig.pipe && headerConfig.pipe == 'date') {
          mappedData.push(data[headerConfig.field]);
        }
        else if (headerConfig.pipe && headerConfig.pipe == 'CurrencyFormatter') {
          mappedData.push(data[headerConfig.field]);
        }
        else if (!this.searchResultsList[headerConfig.field]) {
          mappedData.push("-");
        }
      });
      return mappedData;
    })

    let templateHeaders = searchHeader;
    let templateFileName = this.configData.TransactionDetailsMetaData[this.transactionState].tableHeading;
    wb.Props = {
      Title: templateFileName,
      Subject: "Insurance",
      Author: "MetaMorphoSys",
      CreatedDate: new Date()
    };
    wb.SheetNames.push(templateFileName);
    let ws_data = [[...templateHeaders], ...searchData];
    let ws = XLSX.utils.aoa_to_sheet(ws_data);
    wb.Sheets[templateFileName] = ws;
    let wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
    let xlFile = new Blob([this.sheetToArrayBuffer(wbout)], { type: "application/octet-stream" });
    this.downloadExcelFile(xlFile, `${templateFileName}.xlsx`);
  }

  sheetToArrayBuffer(wbout) {
    let buf = new ArrayBuffer(wbout.length); //convert s to arrayBuffer
    let view = new Uint8Array(buf);  //create uint8array as viewer
    for (let i = 0; i < wbout.length; i++) view[i] = wbout.charCodeAt(i) & 0xFF; //convert to octet
    return buf;
  }

  downloadExcelFile(blob: any, filename: string): boolean {
    if (!filename) filename = 'file.xlsx';
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    a.href = url;
    a.download = filename;
    a.target = "_blank";
    a.click();
    URL.revokeObjectURL(a.href);
    return true;//url;
  }

  initialPayloadInEdit: any;
  activityPanelOpen = false;
  activityPanel(status) {
    this.activityPanelOpen = !!status;
  }

  // close the message ref in NzMessageService after data is fetched
  openActivityTimeline(entityGuid: any) {
    this.workqueueService.getWorkflowAudit(entityGuid, "").subscribe(res => {
      if (res) {
        const messageRef: NzMessageRef = this.msgService.info("Fetching activity timeline...")
        messageRef.onClose.subscribe(() => this.activityPanelOpen = true)
        res.forEach(item => {
          let serviceTask = item.serviceTask
          if ((item.status == 'PENDING' && serviceTask == "proposal_ManualUw") || serviceTask == "REFERRALS") {
            this.fetchCaseForTimeline(entityGuid, messageRef);
          } else if (serviceTask == "proposal_DataEntry" || serviceTask == "proposal_CounterOffer" || serviceTask == "policyAutoUWTask"
            || serviceTask == "LIFEproposal_DataEntry" || serviceTask == "LIFEproposal_CounterOffer"
          ) {
            this.fetchPolicyForTimeline(entityGuid, messageRef);
          }
        });
      }
    });
  }

  private fetchCaseForTimeline(entityGuid: any, messageRef: NzMessageRef) {
    this.policyService.getCaseByGuid(entityGuid).subscribe(resp => {
      if (resp && Object.entries(resp).length > 0) {
        this.transactionDataIO = resp;
        this.msgService.remove(messageRef.messageId)
      } else {
        this.msgService.error("SERVER ERROR - Technical issue occurred, please contact IT Support.")
      }
    });
  }

  private fetchPolicyForTimeline(entityGuid: any, messageRef: NzMessageRef) {
    this.policyService.getPolicyByGuid(entityGuid).subscribe(resp => {
      if (resp && Object.entries(resp).length > 0) {
        this.transactionDataIO = resp;
        this.msgService.remove(messageRef.messageId)
      } else {
        this.msgService.error("SERVER ERROR - Technical issue occurred, please contact IT Support.")
      }
    });
  }
  refreshAfterDataReload = true
  refreshAfterSearch() {
    this.refreshAfterDataReload = false
    setTimeout(() => {
      this.refreshAfterDataReload = true
    }, 100)
  }


}
